module.exports = __webpack_public_path__ + "static/media/google_05.a643b595.svg";